import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
const PHONE_NUMBER = '2066193742';
const DEFAULT_MESSAGE = "Hi, I'm on your website and I have a question";
export function LiveChat() {
  const smsLink = `sms:${PHONE_NUMBER}?body=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  const location = useLocation();
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  const bgColor = isContractors ? 'bg-[#F87431] hover:bg-[#e0662a]' : 'bg-[#2e8a44] hover:bg-[#267338]';
  return <div className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col items-end" data-id="element-538">
      <a href={smsLink} className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-105 ${bgColor} text-white`} aria-label="Text Us" data-id="element-539">
        <MessageCircle className="w-6 h-6" data-id="element-540" />
      </a>
    </div>;
}